import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IApiResponse } from '@core/interfaces/api-response.interface';
import { IRole } from '@core/interfaces/role.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RoleService {
  constructor(private readonly http: HttpClient) {}

  public getRoles(params?: HttpParams): Observable<IApiResponse<IRole[]>> {
    return this.http.get<IApiResponse<IRole[]>>('roles', { params });
  }

  public createRole(payload: { name: string; permissions: string[]; iconId?: string | null }): Observable<IRole> {
    return this.http.post<IRole>('roles', payload);
  }

  public updateRole(
    id: string,
    payload: { name: string; permissions: string[]; iconId?: string | null },
  ): Observable<IRole> {
    return this.http.put<IRole>(`roles/${id}`, payload);
  }

  public deleteRole(id: string): Observable<IRole> {
    return this.http.delete<IRole>(`roles/${id}`);
  }
}
